module.exports = __webpack_public_path__ + "media/images/pages/chevron-down-7a18b67d751ec90d01fe7700a7fc3b87.svg";